import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  display: flex;
  align-items: flex-start;
`;
